import axios from "axios";
import { GetContext } from "./ApplicationContext";

GetContext((context) => {
    axios.defaults.headers.common["X-sca-ide-org-context"] = context.currentOrganization.id;
    axios.defaults.headers.common["X-sca-ide-org-membership"] = context.currentMembership.type;
});

export let TrimFields = (obj) => {
    Object.keys(obj).map((k) => obj[k]?.trim && (obj[k] = obj[k].trim()));
    return obj;
};

export default axios;

export interface DefaultResponse {
    success: boolean;
    message?: string;
    errors: string[];
}

export interface TypedResponse<T> extends DefaultResponse {
    value: T;
}
